import React, { useState } from 'react'
import Button from 'components/button'
import Input from 'components/input'
import {
  REGEX_SPECIAL_CHARACTERS_PASSWORD,
  ALLOWED_SPECIAL_CHARACTERS_PASSWORD,
  REGEX_PASSWORD_MIN_LENGTH,
  MIN_PASSWORD_LENGTH
} from 'app-constants'
export interface IFormValues {
  password1: string
  password2: string
}

interface Props {
  onSubmit: (values: IFormValues) => void
}

const PasswordResetForm: React.FC<Props> = ({ onSubmit }) => {
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [values, setValues] = useState<IFormValues>({
    password1: '',
    password2: ''
  })

  const passwordLengthError = !values.password1.match(REGEX_PASSWORD_MIN_LENGTH)
  const passwordLowercaseError = !values.password1.match(/^(?=.*[a-z])/)
  const passwordUppercaseError = !values.password1.match(/^(?=.*[A-Z])/)
  const passwordNumericError = !values.password1.match(/^(?=.*[0-9])/)
  const passwordSpecialError = !values.password1.match(REGEX_SPECIAL_CHARACTERS_PASSWORD)
  const confirmPasswordError = values.password1 !== values.password2
  const passwordError =
    passwordLengthError ||
    passwordLowercaseError ||
    passwordUppercaseError ||
    passwordNumericError ||
    passwordSpecialError ||
    confirmPasswordError

  const handleSubmit = async () => {
    setSubmitting(true)
    await onSubmit(values)
    setSubmitting(false)
  }

  return (
    <div className="w-full">
      <Input
        placeholder="Your new password"
        type="password"
        onChange={(event) => setValues({ ...values, password1: event.target.value })}
        autoComplete="new-password"
      />
      <p className={`${passwordLengthError ? 'text-red' : 'text-green'} mt-2.5`}>
        {`${passwordLengthError ? '⤫' : '✓'} Password must be at least ${MIN_PASSWORD_LENGTH} characters long`}
      </p>
      <p className={`${passwordLowercaseError ? 'text-red' : 'text-green'} mt-2.5`}>
        {`${passwordLowercaseError ? '⤫' : '✓'} Password must contain at least one lowercase letter`}
      </p>
      <p className={`${passwordUppercaseError ? 'text-red' : 'text-green'} mt-2.5`}>
        {`${passwordUppercaseError ? '⤫' : '✓'} Password must contain at least one uppercase letter`}
      </p>
      <p className={`${passwordNumericError ? 'text-red' : 'text-green'} mt-2.5`}>
        {`${passwordNumericError ? '⤫' : '✓'} Password must contain at least one numeric character`}
      </p>
      <p className={`${passwordSpecialError ? 'text-red' : 'text-green'} mt-2.5`}>
        {`${
          passwordSpecialError ? '⤫' : '✓'
        } Password must contain at least one special character: ${ALLOWED_SPECIAL_CHARACTERS_PASSWORD}`}
      </p>
      <Input
        className="mt-5"
        placeholder="Confirm your new password"
        type="password"
        autoComplete="new-password"
        onChange={(event) => setValues({ ...values, password2: event.target.value })}
      />
      {confirmPasswordError && <p className="text-red mt-2.5">Your passwords do not match</p>}
      <Button
        className="mt-5 w-full text-[1rem]"
        onClick={() => handleSubmit()}
        disabled={passwordError}
        isLoading={submitting}
      >
        Reset Password
      </Button>
    </div>
  )
}

export default PasswordResetForm
